import alertSound from '../../assets/sound_alert.mp3';
import { ISoundState } from './Sound-types';

const soundState: ISoundState = {
    state: {
        soundReady: false,
        audio: null,
    },
    mutations: {
        setSoundReady(state, soundReady: boolean) {
            state.soundReady = soundReady;
        },
        setAudio(state, audio: any) {
            state.audio = audio;
        },
    },
    actions: {
        async setSoundReady({ commit, state, getters }) {
            if (state.soundReady) {
                return;
            }

            try {
                const audio = new Audio(alertSound);
                audio.volume = getters.volume;
                await audio.play();
                await audio.pause();
                commit('setAudio', audio);
                commit('setSoundReady', true);
            } catch (error) {
                console.log('Error readying sound');
            }
        },
        async playSound({ state, getters }) {
            if (getters.muted) {
                return;
            }

            try {
                if (state.audio.volume !== getters.volume) {
                    state.audio.volume = getters.volume;
                }

                await state.audio.play();
            } catch (error) {
                console.log('Error playing sound');
            }
        },
    },
};

export default soundState;
